import { DeveloperToolsHost } from "../developer-tools/DeveloperToolsHost";

import { TinkertoyShell } from "./TinkertoyShell";

/**
 * Catch-all route element: view shell plus dev tools as DOM siblings.
 *
 * Dev tools must not render inside {@link TinkertoyShell}'s view subtree — enrollment
 * layouts use fixed/full-viewport surfaces that paint over in-tree fixed UI even
 * with a high z-index. Keeping the pane as a route-level sibling keeps the toggle
 * visible after the view bundle mounts.
 *
 * When the view bundle fails, React Router renders {@link ShellErrorBoundary}
 * instead of this element; that boundary also mounts {@link DeveloperToolsHost}
 * so bundle overrides can still be cleared from the error page.
 */
export function ShellRoute() {
  return (
    <>
      <TinkertoyShell />
      <DeveloperToolsHost />
    </>
  );
}
